export default __webpack_public_path__ + "static/media/404.a2796d14.gif";